import { CustomRouteParams } from './type.gen'
import { Widget, routerSwitch, route, notFoundRouteCase, Route } from 'widgets-for-react'

export let router = <a, b extends { kind: keyof a }>(
  custom_routes: Route<CustomRouteParams<a, b>>[],
  rootpath: string,
  rootpath_to_ignore: string
): Widget<CustomRouteParams<a, b>> =>
  routerSwitch<CustomRouteParams<a, b>>({ key: `router-switch` })([
    route<{}, CustomRouteParams<a, b>>(rootpath_to_ignore + '/*', _ => ({ kind: 'ignore' })),
    route<{}, CustomRouteParams<a, b>>(rootpath_to_ignore + '/', _ => ({ kind: 'ignore' })),
    //other cases?
    ...custom_routes,
    route<{ slug?: string }, CustomRouteParams<a, b>>(rootpath + '/:slug*', a => ({ kind: 'page', slug: a.slug })),
    notFoundRouteCase<CustomRouteParams<a, b>>(() => ({ kind: '404' }))
  ])
